<ng-container *ngIf="activeFacets$ | async as activeFacets">
  <div class="mb-2 no-gutters">
    <div class="mb-active-facets"
         data-cy="mb-active-facets">
      <div class="my-2 mr-4 d-block d-md-inline mb-active-facets-label"
           [innerHTML]="'searchFilterPane.filteredBy' | mbTranslate"
           *ngIf="activeFacets?.length > 0">
      </div>

      <ng-container *ngFor="let facet of activeFacets, index as i">
        <ng-container *ngIf="i !== 0">
          <div class="mr-3 mb-2 mb-active-facet-term"
               [attr.data-cy]="'mb-active-facet-term-' + +(i-1)">
            <div [innerHTML]="getLogicalTerm(activeFacets[i-1], activeFacets[i]) | mbTranslate"></div>
          </div>
        </ng-container>

        <div class="mr-3 mb-2 mb-active-facet-item"
             [attr.data-cy]="'mb-active-facet-item-' + i">
          <a class="text-decoration-none d-inline mb-active-facet-item-icon"
             rel="nofollow"
             routerLink="./"
             [queryParams]="getLinkParams(facet)"
             (click)="onRemoveFacetClick()"
             *ngIf="!isFacetReadOnly(facet)">
            <span class="d-inline mb-active-facet-item-text"
                  [innerHTML]="facet?.facetName + ' - ' + facet?.facetValueName | safeHtml"></span>
          </a>
          <span *ngIf="isFacetReadOnly(facet)"
                class="d-inline mb-read-only-facet mb-active-facet-item-text"
                [innerHTML]="facet?.facetName + ' - ' + facet?.facetValueName | safeHtml"></span>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
